import React, { Component } from 'react';

export class MovieContainer extends Component {

  render() {
    const { style } = this.props;
    const customAttributes = {
    };
    return (
      <div {...customAttributes} style={style}>{this.props.children}</div>
    );
  }
}

export default MovieContainer;
